const messageConfig = {
    "Your order has been successfully created.": {
      button: null,
    },
    "Your order requirements have been submitted.": {
      button: "View Requirements",
      action: () => console.log("View Requirements clicked"),
    },
    "Your order is pending payment. Please complete the payment to proceed.": {
      button: "Pay Now",
      action: () => console.log("Pay Now clicked"),
    },
    "Your Order is now in progress.": {
      button: null,
    },
    "Your order has been delivered. Please review and accept the delivery.": {
      button: "Review Order",
      action: () => console.log("Review Order clicked"),
    },
    "Your order has been marked as completed. Thank you for using our service.": {
      button: null,
    },
    "Your order has been marked as completed By The Admin. Thank you for using our service": {
      button: null,
    },
    "Your complaint has been received. We will review it and respond shortly.": {
      button: "View Complaint",
      action: () => console.log("View Complaint clicked"),
    },
    "Your complaint has been resolved.": {
      button: null,
    },
    "Your Review has been received. We will review it and respond shortly. .": {
      button: "View Revision",
      action: () => console.log("View Revision clicked"),
    },
    "Your Review has been done. Thank you for your patience.": {
      button: null,
    },
  };
  
  export default messageConfig;
  